import { pillar } from "./pillar";

export {player};


var birdy = new Image();
birdy.src = "birdy.png";


class player {
    x_coord: number;
    y_coord:number;
    height: number;
    acc: number;
    context: CanvasRenderingContext2D;
    window_height: number;
    score: number;

    constructor(context: CanvasRenderingContext2D, height: number) {
        this.x_coord = 50;
        this.y_coord = 50;
        this.height = 135;
        this.acc = 1;
        this.context = context;
        this.window_height = height; 
        this.score = 0;
    }

    check_collision_and_score(pillars: pillar[]) {

        if (this.y_coord > this.window_height) {
            return true;
        } else {
            // mittelpunkt von birdy
            const pl_x = this.x_coord + 356*0.75/2;
            const pl_y = this.y_coord + 232*0.75/2;
            for (let p of pillars) {
                const pillar_x = p.x_coord + 75; //mittelpunkt der säule
                if (pl_x - pillar_x  < 0 && pl_x - pillar_x > -170) {
                    let y_d = pl_y - p.upper_corner;
                    if ((y_d < 100 / 2) || (y_d > p.space_height - 100 / 2)) {   
                        return true;
                    }
                } else if (pl_x - pillar_x  > 0 && pl_x - pillar_x < 170) {
                    if (!p.seen) {
                        p.seen = true;
                        this.score += 1;
                    }
                    let y_d = pl_y - p.upper_corner;
                    if ((y_d < 100) || (y_d > p.space_height - 100)) {   
                        return true;
                    }
                }
            }
        }

    }

    fall(counter: number, pillars: pillar[]) {
        this.acc += 1.5;
        this.y_coord += 1 * this.acc / ((counter % 10)+ 1);
        return this.check_collision_and_score(pillars);
    }

    jump(pillars: pillar[]){
        this.acc = -30;
        return this.check_collision_and_score(pillars);
    }
    
    draw() {
        this.context.drawImage(birdy, this.x_coord, this.y_coord, 356*0.75, 232*0.75);
    }

}